import { Box } from '@mantine/core'
import { useRef } from 'react'
import { createPortal } from 'react-dom'

import { useCoinContext } from '@/app/[locale]/price/[slug]/_contexts/CoinContext'
import useDelayToCall from '@/hooks/useDelayToCall'

import {
  SHARE_DOWNLOAD_HELPER_PORTAL_EL_ID,
  ShareModalContentBaseProps,
  SocialType,
} from '../utils'
import FacebookShareContent from './FacebookShareContent'
import InsShareContent from './InsShareContent'
import TwitterShareContent from './TwitterShareContent'
import { downLoadHTMLToImage } from './utils'

export default function ShareDownloadHelper({
  socialType,
  onDownloadFinished,
  ...otherProps
}: ShareModalContentBaseProps & {
  onDownloadFinished?: () => void
}) {
  const shareContentContainerRef = useRef<HTMLDivElement | null>(null)
  const { coin } = useCoinContext()
  const fileName = [coin.name, socialType, otherProps.shareType].join('-')

  // need waiting for the chart render, 1s is enough
  useDelayToCall(async () => {
    if (!shareContentContainerRef.current) return
    await downLoadHTMLToImage({ dom: shareContentContainerRef.current, fileName })
    onDownloadFinished?.()
  }, 1000)

  const shareContent = (() => {
    if (socialType === SocialType.instagram) {
      return <InsShareContent {...otherProps} contentContainerRef={shareContentContainerRef} />
    }
    if (socialType === SocialType.twitter) {
      return <TwitterShareContent {...otherProps} contentContainerRef={shareContentContainerRef} />
    }
    return <FacebookShareContent {...otherProps} contentContainerRef={shareContentContainerRef} />
  })()
  const portalEl = document.getElementById(SHARE_DOWNLOAD_HELPER_PORTAL_EL_ID)
  const content = (
    <Box pos={'fixed'} style={{ zIndex: -1 }} opacity={0}>
      {shareContent}
    </Box>
  )
  if (!portalEl) return content

  return createPortal(content, portalEl)
}
